import { render, staticRenderFns } from "./CrewForm.vue?vue&type=template&id=a1992bb6"
import script from "./CrewForm.vue?vue&type=script&lang=js"
export * from "./CrewForm.vue?vue&type=script&lang=js"
import style0 from "./CrewForm.vue?vue&type=style&index=0&id=a1992bb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports